import { Clickable } from 'src/app/@shared/models/clickable.model';
import { CText } from 'src/app/@shared/models/text.model';

export class RRDATA {
    readonly title: CText;
    readonly header: DPReviewHeader | null;
    readonly contents: DPReviewContentItem[];
    readonly pageNumber: number;
    readonly isNextPage: boolean;
    readonly onlyHeader: boolean;

    constructor() {
        this.title = { text: '' };
        this.header = null;
        this.contents = [];
        this.pageNumber = 0;
        this.isNextPage = false;
        this.onlyHeader = false;
    }
}

export class DPReviewHeader {
    title: CText;
    subtitle: Text;
    button?: {
        text: string;
        link: string;
    };
    defaultColor: string;
    fillColor: string;
    value?: number;

    constructor(
        title: CText,
        subtitle: Text,
        button: Clickable,
        value: number,
        defaultColor: string,
        fillColor: string
    ) {
        this.title = {
            text: '',
            color: '',
        };
        this.subtitle = subtitle;
        this.button = {
            text: '',
            link: '',
        };
        this.value = value;
        this.defaultColor = '';
        this.fillColor = '';
    }
}

export interface DPReviewContentItem {
    user: {
        name: string;
        status: string;
    };
    title: CText;
    description: Text;
    rating: {
        value: number;
        defaultColor: string;
        fillColor: string;
    };
}
